"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const DisplayGrid = styled_components_1.default.div `
	display: grid;
	grid-template-columns: ${({ gridTemplateColumns }) => gridTemplateColumns};
	grid-gap: ${({ gridGap }) => gridGap};
	width: ${({ gridWidth }) => gridWidth};
	justify-content: center;

	@media (max-width: 41em) {
		grid-template-columns: ${({ mobileGridTemplateColumns }) => mobileGridTemplateColumns};
		grid-gap: 10px;
		width: ${({ mobileWidth }) => mobileWidth};
	}

	div {
		width: 100%;
	}
`;
const defaultProps = {
    mobileWidth: '100%'
};
const Grid = ({ children, gridTemplateColumns, mobileGridTemplateColumns, gridGap, gridWidth, mobileWidth }) => react_1.default.createElement(DisplayGrid, { gridTemplateColumns: gridTemplateColumns, mobileGridTemplateColumns: mobileGridTemplateColumns, gridGap: gridGap, gridWidth: gridWidth, mobileWidth: mobileWidth }, children);
exports.Grid = Grid;
exports.Grid.defaultProps = defaultProps;
